import isMobile from '../utils/isMobile';

// make sure it doesn't target tabs in the toolbar
const tabsElement = document.querySelectorAll('.main-content .tabs');

const contentActiveClass = 'tabs__content--active';
const titleActiveClass = 'tabs__title--active';
// handles toggle of tabs on mobile
const titlesOpenClass = 'tabs__titles--open';

let onMobile = isMobile();

const resetClasses = (items) => {
  items.forEach((item) =>
    item.classList.remove(titleActiveClass, contentActiveClass),
  );
};

const setPosition = (tabContents, activeId) => {
  activeId = activeId || 0;
  tabContents.forEach((content, idx) => {
    // reset any position (which I guess it adds it to 0 0 but not sure if we want that)
    content.style.setProperty('--position', '');

    // this shouldn't happen but just in case
    if (activeId === idx) {
      return;
    }

    // move the rest of the tabs off the screen based
    // on position of the active tab (for direction aware transition)
    if (activeId > idx) {
      content.style.setProperty('--position', '-100%');
    } else {
      content.style.setProperty('--position', '100%');
    }
  });
};

const initMobileDropdown = (tabs) => {
  const tabTitles = tabs.querySelector('.tabs__titles');
  if (tabTitles != null) {
    tabTitles.addEventListener('click', ({ currentTarget, target }) => {
      const clickedOnActive = target.classList.contains(titleActiveClass);
      const dropdownIsOpen = tabTitles.classList.contains(titlesOpenClass);

      if (clickedOnActive && dropdownIsOpen) {
        tabTitles.classList.remove(titlesOpenClass);
        tabTitles.style.setProperty(
          '--dropdown-height',
          `${target.scrollHeight}px`,
        );
      } else {
        tabTitles.classList.add(titlesOpenClass);
        tabTitles.style.setProperty(
          '--dropdown-height',
          `${currentTarget.scrollHeight}px`,
        );
      }
    });
  }
};

const initTabs = (tabs) => {
  const tabTitles = [...tabs.querySelectorAll('.tabs__title')];
  const tabContents = [...tabs.querySelectorAll('.tabs__content')];

  tabTitles.forEach((title) => {
    title.addEventListener('click', ({ target }) => {
      // remove all classes in preparation for setting the active
      resetClasses(tabTitles, tabContents);

      // get active tab/tab content
      const activeTitle = target.dataset.title;
      const tabTitleActive = tabs.querySelector(
        `[data-title="${activeTitle}"]`,
      );
      const tabContentActive = tabs.querySelector(
        `[data-content="${activeTitle}"]`,
      );
      const tabContentActiveId = tabContents.indexOf(tabContentActive);

      // set position of the active tab
      // considering previously active tab
      setPosition(tabContents, tabContentActiveId);

      // set active classes to active tab/tab content
      tabTitleActive.classList.add(titleActiveClass);
      tabContentActive.classList.add(contentActiveClass);
    });
  });
};

const setInitialActiveTab = (tabs) => {
  const tabTitle = tabs.querySelector('.tabs__title');
  const tabContent = tabs.querySelector('.tabs__content');
  if (tabTitle != null && tabContent != null) {
    tabTitle.classList.add(titleActiveClass);
    tabContent.classList.add(contentActiveClass);
    setPosition([...tabContent.parentNode.children]);
  }

  if (onMobile) {
    tabs.firstElementChild.style.setProperty(
      '--dropdown-height',
      `${tabs.firstElementChild.firstElementChild.scrollHeight}px`,
    );
  }
};

(() => {
  // init tabs
  if (tabsElement.length) {
    tabsElement.forEach((tab) => {
      initTabs(tab);
      setInitialActiveTab(tab);

      // add click events for dropdown on mobile
      initMobileDropdown(tab);
    });
  }
})();

if (tabsElement.length) {
  window.addEventListener('resize', () => {
    onMobile = isMobile();

    if (onMobile) {
      tabsElement.forEach((tab) => {
        const tabOpen = tab.querySelector(`.${titlesOpenClass}`);
        if (tabOpen != null) {
          tabOpen.classList.remove(titlesOpenClass);
        }
      });
    }
  });
}
